"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var File_1 = tslib_1.__importDefault(require("./images/File"));
var Email_1 = tslib_1.__importDefault(require("./images/Email"));
var Network_1 = tslib_1.__importDefault(require("./images/Network"));
var NotFound_1 = tslib_1.__importDefault(require("./images/NotFound"));
var Picture_1 = tslib_1.__importDefault(require("./images/Picture"));
var Video_1 = tslib_1.__importDefault(require("./images/Video"));
var Working_1 = tslib_1.__importDefault(require("./images/Working"));
var Chart_1 = tslib_1.__importDefault(require("./images/Chart"));
var utils_1 = require("../utils");
function Empty(props) {
    var _a = props.image, image = _a === void 0 ? 'file' : _a, title = props.title, subtitle = props.subtitle, className = props.className, style = props.style;
    var langData = ConfigProvider_1.useLangData('empty');
    var prefix = ConfigProvider_1.usePrefix('empty');
    return (react_1.default.createElement("div", { className: classnames_1.default(prefix, subtitle && utils_1.concat(prefix, 'has', 'subtitle'), className), style: style },
        image && react_1.default.createElement("span", { className: utils_1.concat(prefix, 'image') }, getImageComponent(image)),
        react_1.default.createElement("span", { className: utils_1.concat(prefix, 'title') }, title || langData.titleText),
        subtitle && react_1.default.createElement("span", { className: utils_1.concat(prefix, 'subtitle') }, subtitle)));
}
exports.Empty = Empty;
function getImageComponent(image) {
    if (image === 'file')
        return react_1.default.createElement(File_1.default, null);
    if (image === 'email')
        return react_1.default.createElement(Email_1.default, null);
    if (image === 'network')
        return react_1.default.createElement(Network_1.default, null);
    if (image === 'picture')
        return react_1.default.createElement(Picture_1.default, null);
    if (image === 'notfound')
        return react_1.default.createElement(NotFound_1.default, null);
    if (image === 'video')
        return react_1.default.createElement(Video_1.default, null);
    if (image === 'working')
        return react_1.default.createElement(Working_1.default, null);
    if (image === 'chart')
        return react_1.default.createElement(Chart_1.default, null);
    return react_1.default.createElement(File_1.default, null);
}
//# sourceMappingURL=index.js.map